import React, { useState } from 'react';

const ITEMS_FINAL = [
  { key: 'estacionamiento', label: 'Locomotora frenada con freno de estacionamiento' },
  { key: 'parking', label: 'Indicadores freno servicio y parking de cada bogie en rojo' },
  { key: 'visual', label: 'Guarniciones de freno aplicadas en todas las ruedas' },
  { key: 'lubricante', label: 'No hay fugas de lubricante, combustible, agua o aire' },
  { key: 'sueltas', label: 'No hay piezas sueltas o que arrastren' },
  { key: 'mando', label: 'Mangueras de mando multiple en su soporte' },
  { key: 'acopla', label: 'Mangueras de acoplamiento de freno en soporte y llaves cerradas' },
  { key: 'combus', label: 'Nivel de combustible y areneros comprobado' },
  { key: 'horas_motor_check', label: 'Horas-motor de la locomotora comprobadas' },
  { key: 'choque', label: 'Organos de traccion y choque en perfecto estado' },
];

function ItemCheck({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ flex: 1, fontSize: 14, lineHeight: 1.4, color: '#333' }}>{label}</div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={() => onChange(true)} style={{ width: 44, height: 44, borderRadius: 8, border: `2px solid ${value === true ? '#3b6d11' : '#ddd'}`, background: value === true ? '#eaf3de' : '#fff', cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✓</button>
        <button onClick={() => onChange(false)} style={{ width: 44, height: 44, borderRadius: 8, border: `2px solid ${value === false ? '#a32d2d' : '#ddd'}`, background: value === false ? '#fcebeb' : '#fff', cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✗</button>
      </div>
    </div>
  );
}

export default function ChecklistFinalForm({ inicial, kmInicio, onGuardar, onVolver }) {
  const init = inicial || {};
  const [seccion, setSeccion] = useState('datos');

  const [hora, setHora] = useState(init.hora || new Date().toTimeString().slice(0, 5));
  const [kmFin, setKmFin] = useState(init.km_fin || '');
  const [kmServicio, setKmServicio] = useState(init.km_servicio || '');
  const [litrosCombustibleFin, setLitrosCombustibleFin] = useState(init.litros_combustible_fin || '');
  const [litrosAdblueFin, setLitrosAdblueFin] = useState(init.litros_adblue_fin || '');
  const [toneladasCombustible, setToneladasCombustible] = useState(init.toneladas_combustible || '');
  const [horasMotor, setHorasMotor] = useState(init.horas_motor || '');

  const [items, setItems] = useState(() => {
    const obj = {};
    ITEMS_FINAL.forEach(i => obj[i.key] = init[i.key] ?? null);
    return obj;
  });
  const [observaciones, setObservaciones] = useState(init.observaciones || '');

  // Calcular km del servicio automáticamente
  const kmCalculado = kmFin && kmInicio ? Math.max(0, parseFloat(kmFin) - parseFloat(kmInicio)) : null;

  const marcados = Object.values(items).filter(v => v !== null).length;
  const secciones = ['datos', 'checklist'];
  const seccionIdx = secciones.indexOf(seccion);

  const guardar = () => {
    if (!kmFin || !litrosCombustibleFin) {
      alert('Rellena los KM y litros de combustible de fin'); return;
    }
    onGuardar({
      hora,
      km_fin: parseFloat(kmFin),
      km_servicio: kmCalculado || (kmServicio ? parseFloat(kmServicio) : 0),
      litros_combustible_fin: parseFloat(litrosCombustibleFin),
      litros_adblue_fin: litrosAdblueFin ? parseFloat(litrosAdblueFin) : null,
      toneladas_combustible: toneladasCombustible ? parseFloat(toneladasCombustible) : null,
      horas_motor: horasMotor ? parseFloat(horasMotor) : null,
      ...items,
      observaciones
    });
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <button onClick={onVolver} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>←</button>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>Checklist final</h1>
          <p style={{ fontSize: 12, color: '#888', margin: '2px 0 0' }}>{marcados}/{ITEMS_FINAL.length} items marcados</p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {[
          { key: 'datos', label: 'Datos fin' },
          { key: 'checklist', label: 'Checklist' },
        ].map(s => (
          <button key={s.key} onClick={() => setSeccion(s.key)} style={{
            flex: 1, padding: '9px 4px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500,
            background: seccion === s.key ? '#1a1a1a' : '#f0f0f0',
            color: seccion === s.key ? '#fff' : '#555'
          }}>{s.label}</button>
        ))}
      </div>

      {seccion === 'datos' && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Hora fin</label>
            <input type="time" value={hora} onChange={e => setHora(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM odometro fin</label>
              <input type="number" value={kmFin} onChange={e => setKmFin(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM del servicio</label>
              {kmCalculado !== null ? (
                <div style={{ padding: '10px', borderRadius: 8, border: '1px solid #97c459', background: '#eaf3de', fontSize: 14, fontWeight: 500, color: '#3b6d11' }}>
                  {kmCalculado.toFixed(0)} km ✓
                </div>
              ) : (
                <input type="number" value={kmServicio} onChange={e => setKmServicio(e.target.value)}
                  placeholder="Se calcula solo"
                  style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
              )}
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Litros combustible fin</label>
              <input type="number" value={litrosCombustibleFin} onChange={e => setLitrosCombustibleFin(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Litros AdBlue fin</label>
              <input type="number" value={litrosAdblueFin} onChange={e => setLitrosAdblueFin(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Toneladas combustible</label>
              <input type="number" value={toneladasCombustible} onChange={e => setToneladasCombustible(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Horas motor</label>
              <input type="number" value={horasMotor} onChange={e => setHorasMotor(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
          </div>
        </div>
      )}

      {seccion === 'checklist' && (
        <div>
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: '0 16px', marginBottom: 16 }}>
            {ITEMS_FINAL.map(item => (
              <ItemCheck key={item.key} label={item.label} value={items[item.key]}
                onChange={v => setItems({ ...items, [item.key]: v })} />
            ))}
          </div>
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 6 }}>Observaciones</label>
            <textarea value={observaciones} onChange={e => setObservaciones(e.target.value)} rows={3}
              placeholder="Observaciones..."
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, resize: 'none', boxSizing: 'border-box' }} />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        {seccionIdx > 0 && (
          <button onClick={() => setSeccion(secciones[seccionIdx - 1])} style={{ flex: 1, padding: '14px', borderRadius: 12, border: '1px solid #ddd', background: '#fff', color: '#333', fontSize: 15, fontWeight: 500, cursor: 'pointer' }}>
            ← Anterior
          </button>
        )}
        {seccionIdx < secciones.length - 1 ? (
          <button onClick={() => setSeccion(secciones[seccionIdx + 1])} style={{ flex: 1, padding: '14px', borderRadius: 12, border: 'none', background: '#1a1a1a', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
            Siguiente →
          </button>
        ) : (
          <button onClick={guardar} style={{ flex: 1, padding: '14px', borderRadius: 12, border: 'none', background: '#1a1a1a', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
            Guardar checklist final
          </button>
        )}
      </div>
    </div>
  );
}
